import ActiveRecord, { sources } from '@mysidewalk/active-record';
class FeatureAvailability extends ActiveRecord {
    /**
     * @param {features.FeatureRecord} feature
     * @returns {Promise<ActiveRecord>}
     */
    static forFeature(feature) {
        return FeatureAvailability.create({
            id: feature.key,
        });
    }
}
class FeatureAvailabilitySource extends sources.ActiveRecordGeobufSource {
    /**
     * @param {object} response
     * @return {Promise<object>}
     */
    transformResponse(response) {
        return (response.headers.get('Content-Type') === 'application/json'
            ? response.text().then(JSON.parse).then(index)
            : Promise.resolve(response));
    }
}
FeatureAvailability.$AR = {
    url: '',
    SourceClass: FeatureAvailabilitySource,
};
function index(body) {
    return body.reduce((memo, entry) => {
        memo[entry.feature_class] = entry;
        return memo;
    }, {});
}
export default FeatureAvailability;
